import CommonApi from '@/pages/api'
import { create } from 'zustand'

/*
{
  "id": 11,
  "title": "Welcome Relait Investor Center",
  "file_name": "Banner.jpg",
  "file_size": "57653",
  "banner": "https://docs.relait.com.au/UAT-Brooksides/investor_center/header/17470441081568558/Banner.jpg",
  "status": "published",
  "animation": false
}
*/

export interface HeaderContent {
  id: number
  title?: string
  file_name?: string
  file_size?: string
  banner?: string
  status?: string
  animation?: boolean
}

interface HeaderContentPrefs {
  headerItems: HeaderContent | null

  fetchHeaderItems: (pathname?: string) => void
  setHeaderItems: (data: HeaderContent) => void
}

export const useHeaderContentStore = create<HeaderContentPrefs>(set => ({
  headerItems: null,

  fetchHeaderItems: async (pathname: any) => {
    try {
      const response = await CommonApi({
        method: 'get',
        path: `show-header-content${pathname == '/homepage-preview' ? '?status=draft' : ''}`
      })
      if (response.status) {
        set({ headerItems: response?.data })
      }
    } catch (error) {
      console.log(error)
    }
  },

  setHeaderItems: data => {
    set({ headerItems: data })
  }
}))
